import { z } from 'zod';

import type { BeneficiaryRefund } from 'domain/usecases';
import type { ProceduresFormValidation } from './types';

export type PreviewRequestFormSchemaValues = {
	beneficiary: BeneficiaryRefund | null;
	procedureSearch?: string;
	selectedProcedure: { code: string; description: string } | null;
};

export function getPreviewRequestFormSchema(
	isConsultation: boolean,
	hasProcedureResults: boolean,
	messages: ProceduresFormValidation,
) {
	return z
		.object({
			beneficiary: z.unknown().nullable(),
			procedureSearch: z.string().optional(),
			selectedProcedure: z.unknown().nullable(),
		})
		.superRefine((data, ctx) => {
			if (!data.beneficiary) {
				ctx.addIssue({
					code: z.ZodIssueCode.custom,
					path: ['beneficiary'],
					message: messages.selectPatient,
				});
			}

			if (!isConsultation) {
				if (!hasProcedureResults) {
					ctx.addIssue({
						code: z.ZodIssueCode.custom,
						path: ['procedureSearch'],
						message: messages.searchAndSelectProcedure,
					});
				}
				if (!data.selectedProcedure) {
					ctx.addIssue({
						code: z.ZodIssueCode.custom,
						path: ['selectedProcedure'],
						message: messages.selectOption,
					});
				}
			}
		});
}
